/**
 * upload组件demo
 * @description upload组件demo
 * @author mll
 * @date 2020-2-4
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool, framework_tool, utils_tool } from '../../../tool'
let { excelUtils } = utils_tool
let { WizUpload, WizIcon, WizButton, WizTypography } = component_tool;
let { WizContainer } = framework_tool;
const { Paragraph, Text } = WizTypography;
import { ExportExcel } from '../../../components/index'

class Upload extends WizContainer {

  componentName = 'UploadDemo';


  _render() {
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '操作',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: constants.files.excel_demo,
      }

    }
    let submit = (file, fileData, other) => {
    }
    let other = [
      {
        /**
         * item的参数
         */
        item: { label: '自定义组件' },
        /**
         * 渲染内容的方法
         */
        comp: (callback) => {
          return (
            <WizButton onClick={() => { callback && callback('button', new Date().getTime()) }}>
              点我向组件输入内容
            </WizButton>
          )
        }
      },
      {
        /**
         * item的参数
         */
        item: { label: '自定义组件2' },
        /**
         * 渲染内容的方法
         */
        comp: (callback) => {
          return (
            <WizButton onClick={() => { callback && callback('button2', '又被点击了') }}>
              点我向组件输入内容
            </WizButton>
          )
        }
      }
    ]
    return (
      <ExportExcel
        infoProps={infoProps}
        operateProps={operateProps}
        submit={submit}
        other={other}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {

  };
};

export default connect(mapStateToProps)(Upload);
